import { Suspense, useEffect } from "react";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
  Outlet,
} from "react-router";
import { appRoutes } from "./features";
import NotFound from "./components/atoms/NotFound";
import { Layout } from "./components/molecules/Layout";
import { CommonLayout } from "./components/molecules/CommonLayout";
import { useGetIdentity } from "@sdk-react-identity/core/hooks";

const App = () => {
  const routes = appRoutes();
  const IsLogin = false;
  const { identity, isPending } = useGetIdentity();
  
  // Separate public routes that should not show the dashboard layout
  const publicPaths = ['/signup', '/makepayment', '/trackshipments', '/trackandtrace', '/privacypolicy', '/terms', '/quotetermsconditions', '/cookiepolicy'];
  const publicRoutes = routes.filter((route: any) => 
    publicPaths.some(path => route.props?.path?.toLowerCase() === path.toLowerCase())
  );
  const dashboardRoutes = routes.filter((route: any) => 
    !publicPaths.some(path => route.props?.path?.toLowerCase() === path.toLowerCase())
  );
  
  return (
    <Router>
      <ScrollTopOnNavigate />
      <Suspense fallback={"Loading..."}>
        <Routes>
          <Route path="/" element={<CommonLayout />}></Route>
          
          {/* Public routes without dashboard layout */}
          <Route element={<Outlet />}>
            {publicRoutes}
          </Route>

          {/* Protected routes with dashboard layout */}
          <Route element={<Layout />}>
            {dashboardRoutes}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
};

const ScrollTopOnNavigate = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default App;
